import React, { useCallback, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Menu, MenuList, MenuWrapper } from 'modals/JaneDetailsModal/JaneMenu/styled';
import { useClickOutside } from 'hooks';
import JaneEllipses from 'modals/JaneDetailsModal/JaneMenu/JaneEllipses';

interface JaneMenuProps {
  disabled: boolean;
  setShowDeactivateConfirmModal: (show: boolean) => void;
  accessStatusName: string;
  reactivateTeamMember: () => void;
}

const JaneMenu: React.FC<JaneMenuProps> = ({
  disabled,
  setShowDeactivateConfirmModal,
  accessStatusName,
  reactivateTeamMember,
}) => {
  const { t } = useTranslation();
  const [openMenu, setOpenMenu] = React.useState(false);
  const menuRef = useRef(null);

  const handleDropdownClose = useCallback(() => {
    if (openMenu) setOpenMenu(false);
  }, [openMenu]);

  useClickOutside([menuRef && menuRef.current], handleDropdownClose);

  const toggleMenu = () => {
    if (disabled) return;
    setOpenMenu(!openMenu);
  };

  const handleReactivationClick = () => {
    reactivateTeamMember();
    setOpenMenu(false);
  };

  const handleDeactivateClick = () => {
    setShowDeactivateConfirmModal(true);
    setOpenMenu(false);
  };

  return (
    <MenuWrapper ref={menuRef}>
      <JaneEllipses disabled={disabled} onClick={toggleMenu} />
      {openMenu && (
        <Menu>
          {accessStatusName === 'blocked' ? (
            <MenuList onClick={handleReactivationClick}>{t('team_member:RE_ACTIVATE')}</MenuList>
          ) : (
            <MenuList onClick={handleDeactivateClick}>{t('team_member:DEACTIVATE')}</MenuList>
          )}
        </Menu>
      )}
    </MenuWrapper>
  );
};

export default JaneMenu;
